module.exports = __webpack_public_path__ + "img/P150T_weapon_29.00b48f6a.png";